module.exports = __webpack_public_path__ + "resources/img/img_ai_fashion3.e6c3549c5bf304355c24e9436dcfa50e.png";